var _circle, _path, _path2, _circle2, _path3, _path4, _circle3, _path5, _path6, _line, _line2, _line3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLargeEcosystem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 397,
    viewBox: "0 0 430 397",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 98.6075,
    cy: 150.489,
    r: 78.5,
    transform: "rotate(-15 98.6075 150.489)",
    stroke: "#192643",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.734 167.606C124.734 189.227 72.4813 189.227 72.4813 167.606V164.865C72.4813 162.398 74.4813 160.398 76.948 160.398H120.269C122.735 160.398 124.735 162.398 124.735 164.865V167.606H124.734Z",
    stroke: "#00B0A6",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.734 132.471C124.734 132.471 110.319 147.786 98.6076 147.786C90.1499 147.786 83.2922 140.928 83.2922 132.471C83.2922 124.013 90.1499 117.155 98.6076 117.155C110.319 117.155 124.734 132.471 124.734 132.471Z",
    stroke: "#00B0A6",
    strokeWidth: 3,
    strokeMiterlimit: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.157,
    cy: 281.895,
    r: 62.5,
    transform: "rotate(-15 261.157 281.895)",
    stroke: "#192643",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M282.058 295.589C282.058 312.886 240.256 312.886 240.256 295.589V293.397C240.256 291.423 241.856 289.823 243.829 289.823H278.486C280.459 289.823 282.059 291.423 282.059 293.397V295.589H282.058Z",
    stroke: "#00B0A6",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M282.058 267.481C282.058 267.481 270.526 279.733 261.157 279.733C254.391 279.733 248.905 274.247 248.905 267.481C248.905 260.715 254.391 255.229 261.157 255.229C270.526 255.229 282.058 267.481 282.058 267.481Z",
    stroke: "#00B0A6",
    strokeWidth: 3,
    strokeMiterlimit: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 314.009,
    cy: 92.7719,
    r: 55.5,
    transform: "rotate(-15 314.009 92.7719)",
    stroke: "#192643",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M332.624 104.968C332.624 120.373 295.394 120.373 295.394 104.968V103.015C295.394 101.258 296.819 99.8326 298.577 99.8326H329.443C331.2 99.8326 332.625 101.258 332.625 103.015V104.968H332.624Z",
    stroke: "#00B0A6",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M332.624 79.934C332.624 79.934 322.354 90.8462 314.009 90.8462C307.983 90.8462 303.097 85.9601 303.097 79.934C303.097 73.9079 307.983 69.0219 314.009 69.0219C322.354 69.0219 332.624 79.934 332.624 79.934Z",
    stroke: "#00B0A6",
    strokeWidth: 3,
    strokeMiterlimit: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 174.527,
    y1: 128.593,
    x2: 258.563,
    y2: 106.076,
    stroke: "black",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 322.19,
    y1: 147.261,
    x2: 299.672,
    y2: 231.297,
    stroke: "black",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 125.513,
    y1: 223.958,
    x2: 200.858,
    y2: 267.458,
    stroke: "black",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeEcosystem);
export default __webpack_public_path__ + "static/media/large_ecosystem.0eb093f83be48cf41c6e6f7896fb3705.svg";
export { ForwardRef as ReactComponent };